import useTranslation from "../hooks/TranslationContext";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div>{t("not-found")}</div>
  );
}
